import {parseISO} from "date-fns";


export const bookingVariantMapper = (data) => {
    return {
        items: Array.isArray(data.items) ? data.items.map(i => itemMapper(i)) : [],

        getPrice(){
            return (this.getPriceCent() / 100).toFixed(2)
        },

        getPriceCent(){
            return this.items.reduce((acc, i) => acc + i.priceCent, 0)
        },

        getArrival(){
            return this.items.reduce(
                (acc, x) => x.arrival < acc ? x.arrival : acc,
                this.items.length > 0 ? this.items[0].arrival : null);
        },

        getDeparture(){
            return this.items.reduce(
                (acc, x) => x.departure > acc ? x.departure : acc,
                this.items.length > 0 ? this.items[0].departure : null);
        },
    }
}

export const itemMapper = (data) => {
    return {
        accommodationType: data.accommodationType,
        accommodationId: data.accommodationId,
        people: data.people,
        arrival: parseISO(data.arrival),
        departure: parseISO(data.departure),
        priceCent: data.priceCent,

        getPrice() {
            return (this.priceCent / 100).toFixed(2);
        }
    }
}

export const availableAccommodationUnitPricesMapper = (data) => {
    return {
        accommodationType: data.accommodationType,
        accommodationId: data.accommodationId,
        arrival: parseISO(data.arrival),
        departure: parseISO(data.departure),

        prices: Array.isArray(data.prices) ? data.prices.map(i => priceMapper(i)) : [],

        getMinPeople() {
            const people = this.prices.filter(p => !!p.priceCent).map(p => p.people)
            return people.length > 0 ? Math.min(...people) : null;
        },

        getMaxPeople() {
            const people = this.prices.filter(p => !!p.priceCent).map(p => p.people)
            return people.length > 0 ? Math.max(...people) : null;
        },

        hasValidPrices() {
            return this.prices.filter(p => !!p.priceCent).length > 0;
        }
    }
}

export const priceMapper = (data) => {
    return {
        priceCent: data.priceCent,
        people: data.people,

        getPrice() {
            return (this.priceCent / 100).toFixed(2);
        }
    }
}